export default __webpack_public_path__ + "scripts/resources/assignments/en/solids/solubilityLargeHeat/spectra.json";